import { TextProps } from "@visx/text";

const WPM_MIN_VALUE = 100;
const WPM_MAX_VALUE = 230;

export const WPM_GAUGE_RANGE: [number, number] = [WPM_MIN_VALUE, WPM_MAX_VALUE];

export const WPM_GAUGE_LABELS: {
  value: number;
  label?: string;
  textAnchor: TextProps["textAnchor"];
}[] = [
  { value: WPM_MIN_VALUE, label: "🐢 slow", textAnchor: "end" },
  { value: 150, textAnchor: "end" },
  { value: 180, textAnchor: "start" },
  { value: WPM_MAX_VALUE, label: "fast 🐇", textAnchor: "start" },
];
